import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { ButtonInterface } from 'common/types/entities/button-interface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

interface ButtonTypeGroupProps {
  entity: ButtonInterface
  title?: string
  hasHorizontalLine?: boolean
}

export const ButtonTypeGroup = ({
  entity,
  title,
  hasHorizontalLine,
}: ButtonTypeGroupProps) => {
  const { t } = useTypedTranslation()
  const updateProp = useUpdateProp(entity)
  return (
    <>
      <GroupTitle withoutHorizontalLine={!hasHorizontalLine}>
        {title ?? t('settings_styles.type.label')}
      </GroupTitle>
      <Switcher
        btnList={[
          {
            value: WebsiteSettingsTypographyTypeEnum.PrimaryButton,
            content: 'website_styles_settings.buttons_and_links.primary.title',
          },
          {
            value: WebsiteSettingsTypographyTypeEnum.SecondaryButton,
            content:
              'website_styles_settings.buttons_and_links.secondary.title',
          },
        ]}
        value={
          entity?.buttonType ?? WebsiteSettingsTypographyTypeEnum.PrimaryButton
        }
        update={updateProp('buttonType')}
      />
    </>
  )
}
